<template>
  <b-button-group>
    <b-button v-for="(button,idx) in buttons" :key="button.text" :class="[['btn', 'tw-w-full'], button.classes, calcCss(idx)]" @click.prevent="buttonSelected(button, idx)"  :pressed="selected === idx">
      {{ button.text }}
    </b-button>
  </b-button-group>
</template>

<script>
export default {
  name: 'ButtonGroupBS',
  props: {
    buttons: Array,
    value: Number
  },
  data () {
    return {
      baseClasses: 'tw-w-full tw-h-10 tw-px-5 tw-transition-colors tw-duration-150',
      firstClass: '',
      lastClass: '',
      selected: this.value
    }
  },
  computed: {
    first_button () {
      return this.buttons[0]
    },
    middle_buttons () {
      return this.buttons.slice(1, this.buttons.length - 1)
    },
    last_button () {
      return this.buttons[this.buttons.length - 1]
    }
  },
  methods: {
    calcCss (idx) {
      if (this.selected === idx) {
        return ['tw-focus']
      }
    },
    buttonSelected (btn, idx) {
      btn.selected_classes = ['tw-bg-indigo-50']
      console.log(idx)
      this.selected = idx
      this.$emit('input', this.selected)
    }
  }
}
</script>

<style scoped>
@tailwind base;
@tailwind components;

.btn {
  @apply tw-relative tw-text-center tw-items-center tw-px-2 tw-py-2 tw-border tw-border-gray-300 tw-leading-5 tw-font-medium tw-transition tw-ease-in-out tw-duration-150;
}

/*.btn:hover {*/
/*  @apply text-gray-400;*/
/*}*/

/*.btn:focus {*/
/*  @apply z-10 border-4*/
/*}*/

.btn:focus {
  @apply tw-border-4 tw-border-kloudpurple tw-outline-none;
}

.active {
  @apply tw-border-4 tw-border-kloudpurple tw-outline-none;
}

/*.btn:active {*/
/*  @apply border-4 bg-gray-100 text-gray-500;*/
/*}*/

.btn-group {
  @apply tw-relative tw-z-0 tw-inline-flex tw-shadow-sm;
}


</style>
